import mitt from 'mitt';

type Events = {
  showLoading: void;
  hideLoading: void;
  forceLogout: void;
};

const eventEmitter = mitt<Events>();

export default eventEmitter;